<template>
  <div id="Notes">
    <div class="header">
      <div class="back-to-toc" @click="$router.go(-1)">
        <v-icon>mdi-chevron-left</v-icon>
        <div class="link-text">Back</div>
      </div>
      <div class="header-content">
        <img :src="TextIcon">
        <div class="note-type">
          Notes
        </div>
      </div>
      <div class="header-content">
        <div class="note-title">
          {{chapterTitle}}
        </div>
      </div>
    </div>
    <div class="notes-body">
      <div class="page-container">
        <div class="card" v-if="this.sectionContent">
          <div class="card-content">
           <span v-html="this.sectionContent"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import TextIcon from '../../public/img/icons/content_icon.png'

export default {
  name: 'Notes',
  mounted () {
    this.formatContents()
    this.addGTMEvent()
  },
  data: () => ({
    nav: false,
    items: 1,
    stagePadding: 35,
    dots: false,
    margin: 10,
    chapterObject: '',
    TextIcon
  }),
  methods: {
    async formatContents () {
      await MathJax.typesetPromise()
      setImagesLightBox()
      setTablesSideScroll()
    },
    addGTMEvent () {
      let cfVideos = document.querySelectorAll('iframe')

      cfVideos.forEach(cfVideo => {
        let cfPlayer = Stream(cfVideo)
        let isOnLoop = false
        if (cfVideo.src.includes('loop=true')) {
          isOnLoop = true
        }

        cfPlayer.addEventListener('play', () => {
          this.$gtm.trackEvent({
            event: 'user_played_video',
            category: 'Notes',
            action: 'play',
            label: 'User played video',
            productName: this.bookTitle,
            chapterName: this.chapter,
            sectionTitle: this.section,
            videoTitle: this.nowPlaying,
            isMediaPlayed: 'true',
            isVideoOnLoop: isOnLoop
          })
        })

        if (!isOnLoop) {
          cfPlayer.addEventListener('ended', () => {
            this.$gtm.trackEvent({
              event: 'user_finished_video',
              category: 'Notes',
              action: 'completed',
              label: 'User finished watching video',
              productName: this.bookTitle,
              chapterName: this.chapter,
              sectionTitle: this.section,
              videoTitle: this.nowPlaying,
              isMediaFinished: 'true'
            })
          })
        }
      })
    }
  },
  computed: {
    ...mapState({
      chapterMap: state => state.book.chapterMap,
      chapterHeading: state => state.book.chapterHeading,
      chapterTitle: state => state.book.chapterTitle,
      sectionContent: state => state.book.sectionContent
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables.scss";
#Notes {
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: #f2f2f2;
    .back-to-toc {
      display: flex;
      cursor: pointer;
      .v-icon {
        color: #212121;
      }
      .link-text {
        font-weight: bold;
        font-size: 16px;
      }
    }
    .header-content {
      display: flex;
      align-items: center;
      margin-left: 20px;
      img {
        width: 32px;
        margin-right: 10px;
        display: none;
      }
      .note-type {
        font-size: $PageTitle;
      }
      .note-title {
        font-size: $PageTitle;
      }
    }
  }
  .page-container {
    max-width: 1600px;
    margin: auto;
    height: 100%;
  }

  .notes-body {
    padding: 16px;
    .card {
      height: 100%;
      background-color: #fff;
      border-style: solid;
      border-width: 1px;
      border-color: $outline-border-gray;
      .card-header {
        font-size: $PageTitle;
        padding: 15px;
        background-color: $card-header-color;
        font-weight: bold;
      }
      .card-content {
        padding: 15px;
        height: 100%;
      }
    }

    ::v-deep img {
      display: block;
      max-width: 100%;
    }
  }
}

@media (max-width: 600px) {
  #Notes {
    .header {
      padding: 15px;
      .header-content {
        .note-title {
          display: none;
        }
      }
    }
  }
}

@media (min-width: 1440px) {
  #Notes {
    .header {
      .header-content {
        img {
          display: block;
        }
      }
    }
  }
}
</style>
